/* eslint-disable */
// @ts-nocheck
/* eslint-disable no-irregular-whitespace */
/* eslint-disable react/no-unknown-property */
/* eslint-disable prefer-template */
/* eslint-disable react/self-closing-comp */
/* eslint-disable import/no-unresolved */
/* eslint-disable padding-line-between-statements, import/order, import/newline-after-import, spaced-comment */
/* eslint-disable @typescript-eslint/no-unused-vars, react/jsx-newline, react/jsx-no-bind, no-else-return */
/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps, @typescript-eslint/no-use-before-define, no-lonely-if, no-nested-ternary, import/no-extraneous-dependencies */
/* eslint-disable object-shorthand */
/* eslint-disable react/jsx-newline */
/* eslint-disable react/button-has-type */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable react/jsx-curly-brace-presence */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
import React, { useState, useEffect } from 'react';
import { Card, Descriptions, Typography, Row, Col, Table, Divider, Empty } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';
import { useIntl } from 'react-intl';
import moment from 'moment';
const { Title, Text } = Typography;

// Inline styles
const styles = {
  journalEntryContainer: {
    width: '100%',
    margin: '16px 0',
    border: '1px solid #f0f0f0',
    borderRadius: '4px',
    overflow: 'hidden',
    textAlign: 'center'
  },
  journalEntryHeader: {
    background: '#fafafa',
    padding: '12px 16px',
    borderBottom: '1px solid #f0f0f0',
    fontWeight: 500,
    textAlign: 'center'
  },
  journalEntryTable: {
    width: '100%',
    fontSize: '14px'
  },
  journalEntryRow: {
    display: 'flex',
    borderBottom: '1px solid #f0f0f0'
  },
  journalEntryCell: (flex = 1, align = 'left') => ({
    padding: '12px 16px',
    flex: flex,
    textAlign: align,
    borderRight: '1px solid #f0f0f0',
    fontSize: '12px',
    ':last-child': {
      borderRight: 'none'
    }
  }),
  journalEntryFooter: {
    background: '#fafafa',
    padding: '12px 16px',
    borderTop: '1px solid #f0f0f0',
    fontWeight: 500,
    textAlign: 'center'
  }
};

const ReviewSettlement = ({ data, onDataChange, onConfirm, loading }) => {
  const intl = useIntl();

  // Helper function to format financial values
  const formatAmount5 = (value) => {
    return Number(value || 0).toLocaleString('en-US', { minimumFractionDigits: 5, maximumFractionDigits: 5 });
  };
  const formatAmount2 = (value) => {
    return Number(value || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };
  const fmt = (d) => {
    if (!d) return d;
    try {
      return moment(d).format('DD-MM-YYYY');
    } catch (error) {
      console.warn('Date formatting error in ReviewSettlement:', error, d);
      return d;
    }
  };
  const [confirmModalVisible, setConfirmModalVisible] = useState(false);

  const getSenderName = () => {
    return data.sender_name || intl.formatMessage({ id: 'settlement_SenderNotSelected' });
  };

  const getBeneficiaryName = () => {
    return data.beneficiary_name || intl.formatMessage({ id: 'settlement_BeneficiaryNotSelected' });
  };

  const getSettlementTypeName = () => {
    // You would get this from settlement types data
    return intl.formatMessage({ id: 'settlement_NetSettlement' }); // Mock data
  };

  const getSenderBankName = () => {
    // Only show the actual bank name here; account is shown in its own row
    return data.sender_bank_name || intl.formatMessage({ id: 'settlement_SenderBankNotSelected' });
  };

  const getBeneficiaryBankName = () => {
    // Only show the actual bank name here; account is shown in its own row
    return data.beneficiary_bank_name || intl.formatMessage({ id: 'settlement_BeneficiaryBankNotSelected' });
  };

  const getSenderBankAccountDisplay = () => {
    return data.sender_bank_display || intl.formatMessage({ id: 'settlement_SenderAccountNotSelected' });
  };

  const getBeneficiaryBankAccountDisplay = () => {
    return data.beneficiary_bank_display || intl.formatMessage({ id: 'settlement_BeneficiaryAccountNotSelected' });
  };

  const getAccountName = (accountId) => {
    // Get account names without codes, using translations
    const accountNames = {
      'sender_debit_account_id': intl.formatMessage({ id: 'settlement_UnsettledDues' }),
      'sender_credit_account_id': intl.formatMessage({ id: 'settlement_BankAccountAssetName' }),
      'sender_income_account_id': intl.formatMessage({ id: 'settlement_CommissionIncomeAccount' }),
      'sender_tax_liability_account_id': intl.formatMessage({ id: 'settlement_VATPayableAccount' }),
      'beneficiary_debit_account_id': intl.formatMessage({ id: 'settlement_OperatingAccountName' }),
      'beneficiary_credit_account_id': intl.formatMessage({ id: 'settlement_FareRevenueAccount' }),
      'beneficiary_expense_account_id': intl.formatMessage({ id: 'settlement_CommissionExpenseAccount' }),
      'beneficiary_tax_asset_account_id': intl.formatMessage({ id: 'settlement_VATReceivableAccount' })
    };
    return accountNames[accountId] || intl.formatMessage({ id: 'settlement_UnknownAccount' });
  };

  // Sender suggested journal entries (our company)
  // Using summed values to match Step2 totals display
  const summedFees = data.summed_fees || data.fees_amount || 0;
  const summedVAT = data.summed_vat || data.tax_amount || 0;

  const journalEntries = [
    {
      account: getAccountName('sender_debit_account_id'),
      debit: Math.abs(data.amount) + summedFees + summedVAT,
      credit: null,
      description: intl.formatMessage({ id: 'settlement_ClearUnsettledDuesLiability' })
    },
    {
      account: getAccountName('sender_credit_account_id'),
      debit: null,
      credit: Math.abs(data.amount),
      description: intl.formatMessage({ id: 'settlement_NetCashTransferredToPTO' })
    },
    {
      account: getAccountName('sender_tax_liability_account_id'),
      debit: null,
      credit: summedVAT,
      description: intl.formatMessage({ id: 'settlement_VATOnFeesTotal' })
    },
    {
      account: getAccountName('sender_income_account_id'),
      debit: null,
      credit: summedFees,
      description: intl.formatMessage({ id: 'settlement_TotalFeesEarnedSummed' })
    }
  ];

  // Beneficiary suggested journal entries (PTO)
  // Using summed values to match Step2 totals display
  const beneficiaryJournalEntries = [
    {
      account: getAccountName('beneficiary_debit_account_id'),
      debit: Math.abs(data.amount),
      credit: null,
      description: intl.formatMessage({ id: 'settlement_NetCashReceivedFromSender' })
    },
    {
      account: getAccountName('beneficiary_expense_account_id'),
      debit: summedFees,
      credit: null,
      description: intl.formatMessage({ id: 'settlement_CommissionExpenseTotal' })
    },
    {
      account: getAccountName('beneficiary_tax_asset_account_id'),
      debit: summedVAT,
      credit: null,
      description: intl.formatMessage({ id: 'settlement_VATOnCommissionTotal' })
    },
    {
      account: getAccountName('beneficiary_credit_account_id'),
      debit: null,
      credit: Math.abs(data.amount) + summedFees + summedVAT,
      description: intl.formatMessage({ id: 'settlement_RecognizeFareRevenueAndFeesTotal' })
    }
  ];

  const journalColumns = [
    {
      title: intl.formatMessage({ id: 'settlement_Account' }),
      dataIndex: 'account',
      key: 'account',
    },
    {
      title: intl.formatMessage({ id: 'settlement_Debit' }),
      dataIndex: 'debit',
      key: 'debit',
      align: 'right',
      render: (value) => value ? `${formatAmount5(value)} EGP` : '-',
    },
    {
      title: intl.formatMessage({ id: 'settlement_Credit' }),
      dataIndex: 'credit',
      key: 'credit',
      align: 'right',
      render: (value) => value ? `${formatAmount5(value)} EGP` : '-',
    },
    {
      title: intl.formatMessage({ id: 'settlement_Description' }),
      dataIndex: 'description',
      key: 'description',
    },
  ];

  // Print and confirm actions have been moved to the wizard footer and post-confirmation modal.

  const totalDebit = journalEntries.reduce((sum, entry) => sum + (entry.debit || 0), 0);
  const totalCredit = journalEntries.reduce((sum, entry) => sum + (entry.credit || 0), 0);
  const isBalanced = Math.abs(totalDebit - totalCredit) < 0.01;

  const benTotalDebit = beneficiaryJournalEntries.reduce((sum, entry) => sum + (entry.debit || 0), 0);
  const benTotalCredit = beneficiaryJournalEntries.reduce((sum, entry) => sum + (entry.credit || 0), 0);
  const benIsBalanced = Math.abs(benTotalDebit - benTotalCredit) < 0.01;

  return (
    <div className="review-settlement">
      <Card>
        <Title level={4}>
          <CheckCircleOutlined /> {intl.formatMessage({ id: 'settlement_ReviewSettlementTitle' })}
        </Title>

        {/* Section 1: Period at top (styled like Amount & Currency) */}
        <Row gutter={[24, 16]} style={{ marginTop: 8 }}>
          <Col xs={24}>
            <Descriptions title={intl.formatMessage({ id: 'settlement_PeriodLabel' })} column={2} bordered size="small">
              <Descriptions.Item label={intl.formatMessage({ id: 'settlement_From' })}>
                <Text>{fmt(data.settlement_from_date)}</Text>
              </Descriptions.Item>
              <Descriptions.Item label={intl.formatMessage({ id: 'settlement_To' })}>
                <Text>{fmt(data.settlement_till_date)}</Text>
              </Descriptions.Item>
            </Descriptions>
          </Col>
        </Row>

        {/* Section 2: Parties & Banks under the period */}
        <Row gutter={[24, 16]} style={{ marginTop: 12 }}>
          <Col xs={24} md={12}>
            <Descriptions title={intl.formatMessage({ id: 'settlement_SenderOurCompany' })} column={1} bordered size="small">
              <Descriptions.Item label={intl.formatMessage({ id: 'settlement_Organisation' })}>{getSenderName()}</Descriptions.Item>
              <Descriptions.Item label={intl.formatMessage({ id: 'settlement_Bank' })}>{getSenderBankName()}</Descriptions.Item>
              <Descriptions.Item label={intl.formatMessage({ id: 'settlement_BankAccount' })}>{getSenderBankAccountDisplay()}</Descriptions.Item>
            </Descriptions>
          </Col>

          <Col xs={24} md={12}>
            <Descriptions title={intl.formatMessage({ id: 'settlement_BeneficiaryPTO' })} column={1} bordered size="small">
              <Descriptions.Item label={intl.formatMessage({ id: 'settlement_Organisation' })}>{getBeneficiaryName()}</Descriptions.Item>
              <Descriptions.Item label={intl.formatMessage({ id: 'settlement_Bank' })}>{getBeneficiaryBankName()}</Descriptions.Item>
              <Descriptions.Item label={intl.formatMessage({ id: 'settlement_BankAccount' })}>{getBeneficiaryBankAccountDisplay()}</Descriptions.Item>
            </Descriptions>
          </Col>
        </Row>

        {/* Amount & Currency section under parties, styled similarly */}
        <Row gutter={[24, 16]} style={{ marginTop: 12 }}>
          <Col xs={24}>
            <Descriptions title={intl.formatMessage({ id: 'settlement_AmountAndCurrency' })} column={2} bordered size="small">
              <Descriptions.Item label={intl.formatMessage({ id: 'settlement_Amount' })}>
                <Text>{formatAmount2(data.amount)}</Text>
              </Descriptions.Item>
              <Descriptions.Item label={intl.formatMessage({ id: 'settlement_Currency' })}>
                <Text>{data.currency || intl.formatMessage({ id: 'settlement_EGP' })}</Text>
              </Descriptions.Item>
            </Descriptions>
          </Col>
        </Row>



        {/* Section 3: Suggested ERP Journal Entries - Sender then Beneficiary */}
        <div style={{ marginTop: 24 }}>
          {/* Sender Journal Entry */}
          <div style={styles.journalEntryContainer}>
            <div style={styles.journalEntryHeader}>{intl.formatMessage({ id: 'settlement_SuggestedERPJournalEntrySenderTitle' })}</div>
            <div style={styles.journalEntryTable}>
              <div style={{ ...styles.journalEntryRow, background: '#fafafa', fontWeight: 500 }}>
                <div style={styles.journalEntryCell(3)}>{intl.formatMessage({ id: 'settlement_Account' })}</div>
                <div style={styles.journalEntryCell(1, 'right')}>{intl.formatMessage({ id: 'settlement_Debit' })}</div>
                <div style={styles.journalEntryCell(1, 'right')}>{intl.formatMessage({ id: 'settlement_Credit' })}</div>
                <div style={{ ...styles.journalEntryCell(2), borderRight: 'none' }}>{intl.formatMessage({ id: 'settlement_Description' })}</div>
              </div>
              {journalEntries.map((entry, index) => (
                <div key={index} style={styles.journalEntryRow}>
                  <div style={styles.journalEntryCell(3)}>{entry.account}</div>
                  <div style={styles.journalEntryCell(1, 'right')}>
                    {entry.debit ? `${formatAmount5(entry.debit)} EGP` : '-'}
                  </div>
                  <div style={styles.journalEntryCell(1, 'right')}>
                    {entry.credit ? `${formatAmount5(entry.credit)} EGP` : '-'}
                  </div>
                  <div style={{ ...styles.journalEntryCell(2), borderRight: 'none' }}>{entry.description}</div>
                </div>
              ))}
              <div style={{ ...styles.journalEntryRow, background: '#fafafa', fontWeight: 500 }}>
                <div style={styles.journalEntryCell(3)}>{intl.formatMessage({ id: 'settlement_Total' })}</div>
                <div style={styles.journalEntryCell(1, 'right')}>
                  {formatAmount5(totalDebit)} EGP
                </div>
                <div style={styles.journalEntryCell(1, 'right')}>
                  {formatAmount5(totalCredit)} EGP
                </div>
                <div style={{ ...styles.journalEntryCell(2), borderRight: 'none' }}></div>
              </div>
            </div>
          </div>

          <div style={{ marginTop: 24 }} />

          {/* Beneficiary Journal Entry */}
          <div style={styles.journalEntryContainer}>
            <div style={styles.journalEntryHeader}>{intl.formatMessage({ id: 'settlement_SuggestedERPJournalEntryBeneficiaryTitle' })}</div>
            <div style={styles.journalEntryTable}>
              <div style={{ ...styles.journalEntryRow, background: '#fafafa', fontWeight: 500 }}>
                <div style={styles.journalEntryCell(3)}>{intl.formatMessage({ id: 'settlement_Account' })}</div>
                <div style={styles.journalEntryCell(1, 'right')}>{intl.formatMessage({ id: 'settlement_Debit' })}</div>
                <div style={styles.journalEntryCell(1, 'right')}>{intl.formatMessage({ id: 'settlement_Credit' })}</div>
                <div style={{ ...styles.journalEntryCell(2), borderRight: 'none' }}>{intl.formatMessage({ id: 'settlement_Description' })}</div>
              </div>
              {beneficiaryJournalEntries.map((entry, index) => (
                <div key={index} style={styles.journalEntryRow}>
                  <div style={styles.journalEntryCell(3)}>{entry.account}</div>
                  <div style={styles.journalEntryCell(1, 'right')}>
                    {entry.debit ? `${formatAmount5(entry.debit)} EGP` : '-'}
                  </div>
                  <div style={styles.journalEntryCell(1, 'right')}>
                    {entry.credit ? `${formatAmount5(entry.credit)} EGP` : '-'}
                  </div>
                  <div style={{ ...styles.journalEntryCell(2), borderRight: 'none' }}>{entry.description}</div>
                </div>
              ))}
              <div style={{ ...styles.journalEntryRow, background: '#fafafa', fontWeight: 500 }}>
                <div style={styles.journalEntryCell(3)}>{intl.formatMessage({ id: 'settlement_Total' })}</div>
                <div style={styles.journalEntryCell(1, 'right')}>
                  {formatAmount5(benTotalDebit)} EGP
                </div>
                <div style={styles.journalEntryCell(1, 'right')}>
                  {formatAmount5(benTotalCredit)} EGP
                </div>
                <div style={{ ...styles.journalEntryCell(2), borderRight: 'none' }}></div>
              </div>
            </div>
          </div>
        </div>

        {/* Bank Transfer Notes */}
        <Row gutter={[24, 16]} style={{ marginTop: 24 }}>
          <Col xs={24}>
            <Card size="small" title={intl.formatMessage({ id: 'settlement_BankTransferNotesTitle' })}>
              <Text>{data.notes || intl.formatMessage({ id: 'settlement_NoAdditionalNotes' })}</Text>
            </Card>
          </Col>
        </Row>

        {/* Navigation is handled by the wizard footer; print moved to post-confirmation modal */}
      </Card>
    </div>
  );
};

export default ReviewSettlement;
